module.exports = __webpack_public_path__ + "img/05597965000470.fbbd95a5.png";